export default {_name:'list.simple.item',module:'Field',view:'Element/List/Item/Simple',options:{xs:10,md:12}}